const convertMillisecondsToSeconds = (milliseconds = 0) => {
	const seconds = Math.floor(milliseconds / 1000);
	return seconds;
};

const timeToDecimal = (time = "00:00") => {
	var hoursMinutes = time.split(/[.:]/);
	var hours = parseInt(hoursMinutes[0], 10);
	var minutes = hoursMinutes[1] ? parseInt(hoursMinutes[1], 10) : 0;
	return hours + minutes / 60;
};

export const changeMillisecondsToDecimal = (number = 0) => {
	const seconds = convertMillisecondsToSeconds(number);
	const minutes = changeToHoursMinutes(seconds);
	const decimalHours = timeToDecimal(minutes);
	return Number(decimalHours.toFixed(2));
};

export const changeHoursForMinute = (time = 0) => {
	const decimalTime = time * 3600;
	let minutes = Math.round(decimalTime / 60);
	minutes = parseInt(minutes);
	return minutes;
};

export const changeHoursForSeconds = (time = 0) => {
	const decimalTime = time * 60 * 60;
	let timeConvert = parseInt(decimalTime);
	return timeConvert;
};

export const decimalToHours = (decimal = 0) => {
	const temp = decimal.toFixed(2);
	const separete = temp.split(".");
	let hous = separete[0];
	let minutes = 100 / separete[1];
	minutes = 60 / minutes;
	return `${hous}:${minutes}`;
};

const changeToHoursMinutes = (seconds = 0) => {
	const hoursLeft = Math.floor(seconds / 3600);
	const min = Math.floor((seconds - hoursLeft * 3600) / 60);
	let answer = hoursLeft < 10 ? "0" + hoursLeft : hoursLeft;
	answer += ":" + (min < 10 ? "0" + min : min);
	return answer;
};

export const changeSecondsToDecimal = (seconds = 0) => {
	const hoursString = changeToHoursMinutes(seconds);
	const decimal = timeToDecimal(hoursString);
	return decimal;
};

export const getLastDayMonth = (month, year) => {
	var date = new Date(year, month, 0);
	var lastDay = date.getDate();
	return lastDay;
};
